import { render, staticRenderFns } from "./global_reward_edit.vue?vue&type=template&id=6b70eb65&scoped=true&"
import script from "./global_reward_edit.vue?vue&type=script&lang=js&"
export * from "./global_reward_edit.vue?vue&type=script&lang=js&"
import style0 from "./global_reward_edit.vue?vue&type=style&index=0&id=6b70eb65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70eb65",
  null
  
)

export default component.exports